import { SidePanelTabs } from './components/SidePanel/consts';

// better name for both @iamsaumya
export type TMEditorProps = {
  id: string;
  meetingInstanceId: string;
  mainTabId: MeetingViewsEnum;
  subTabId: SidePanelTabs;
};

export enum MeetingViewsEnum {
  Tasks = 'tasks',
  Agendas = 'agendas',
}
